<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <h2>{{translate?.general.buttons.liveFormPreview.singular}}</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>{{translate?.setup.modules.types.messages.plannersSee}} {{translate?.jobOrder.label.singular}} {{translate?.setup.modules.types.label.singular}}.</h3>
    </div>

    <div class="flx-modal__body p-0">
        <app-add-edit-job-order-v2 [isLivePreviewForm]="true" [livePreviewFormData]="data"></app-add-edit-job-order-v2>
    </div>

     <div class="flx-modal__footer">
        <button type="button"class="custella-btn-white" (click)="onCancelClick()">{{translate?.general.buttons.cancel.singular}}</button>
    </div>
</div>